var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Selezionando i posti che preferisci ti godrai un viaggio più comodo. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }